import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'CaptchaService',
    controller: 'Captcha'
}
const methods = [
    'CheckValiCode'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.get(path, data)
        }
    })
}

const CaptchaApi = ZJApi.defineNewApi('CaptchaApi', factory)

export default CaptchaApi